export default __webpack_public_path__ + "static/O6-colonel-f1095409bff226891d0ef18d3ae923db.png";